import React, { Ref, forwardRef, useImperativeHandle, useState } from 'react';
import { watchEvent } from 'src/js/events';

interface GiantSpinnerProps {
  className?: string;
}

export interface GiantSpinnerRef {
  show?: () => void;
}

// To be used with Apply buttons
export const GiantSpinner = forwardRef((props: GiantSpinnerProps, ref: Ref<GiantSpinnerRef>) => {
  const { className, ...rest } = props;
  const [shown, setShow] = useState(false);

  const show = () => {
    setShow(true);
  };

  watchEvent('show-giant-spinner', () => {
    setShow(true);
  });

  watchEvent('close-giant-spinner', () => {
    setShow(false);
  });

  useImperativeHandle(ref, () => ({ show })); // hook internal show() to our forwarded props

  if (shown === false) {
    return undefined;
  }

  return (
    <div id="giant-spinner" className={className} {...rest}>
      <div id="giant-backdrop" />
      <div id="giant-spinner-core">
        <div className="hai-loader temp-position">
          <svg id="hai-loader-outer-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <path d="M24,46c-12.15,0-22-9.85-22-22S11.85,2,24,2" vectorEffect="non-scaling-stroke" fill="none"></path>
          </svg>
          <div className="hai-loader-inner-wrapper">
            <svg id="hai-loader-inner-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <path d="M46,24c0,12.15-9.85,22-22,22" vectorEffect="non-scaling-stroke" fill="none" />
              <path d="M2,24C2,11.85,11.85,2,24,2" vectorEffect="non-scaling-stroke" fill="none" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
});

GiantSpinner.displayName = 'giantSpinner';
